import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingAppointment from './components/FloatingAppointment';
import ScrollToTop from './components/ScrollToTop';
import SEO from './components/SEO';
import Home from './pages/Home';
import ContactPage from './pages/ContactPage';
import AppointmentPage from './pages/AppointmentPage';
import InnerPage from './pages/InnerPage';
import DentalVideosPage from './pages/DentalVideosPage';
import './styles/globals.css';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <div className="app">
            <SEO />
			      <ScrollToTop />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact-us" element={<ContactPage />} />
              <Route path="/appointment-request" element={<AppointmentPage />} />
              {/* All other pages use InnerPage component */}
              <Route path="/our-practice" element={<InnerPage />} />
              <Route path="/our-practice/*" element={<InnerPage />} />
              <Route path="/payment-options" element={<InnerPage />} />
              <Route path="/cosmetic-dentistry" element={<InnerPage />} />
              <Route path="/cosmetic-dentistry/*" element={<InnerPage />} />
              <Route path="/family-dentistry" element={<InnerPage />} />
              <Route path="/procedures" element={<InnerPage />} />
              <Route path="/procedures/*" element={<InnerPage />} />
              <Route path="/education-and-resources" element={<InnerPage />} />
              <Route path="/education-and-resources/dental-videos" element={<DentalVideosPage />} />
              <Route path="/education-and-resources/*" element={<InnerPage />} />
              <Route path="/privacy-policy" element={<InnerPage />} />
              <Route path="/terms-and-conditions" element={<InnerPage />} />
              <Route path="*" element={<InnerPage />} />
            </Routes>
			<FloatingAppointment />
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
